import { render } from "./HopitalindexComponent.vue?vue&type=template&id=bb324aa8"
import script from "./HopitalindexComponent.vue?vue&type=script&lang=js"
export * from "./HopitalindexComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__